<template>
  <div
    class="notification-message"
    role="status"
    tabindex="0"
    @click="emit('close')"
    @keydown.enter="emit('close')"
    @keydown.space.prevent="emit('close')"
  >
    {{ message }}
  </div>
</template>

<script setup lang="ts">
defineProps<{
  message: string;
}>();

const emit = defineEmits<{
  (event: 'close'): void;
}>();
</script>

<style scoped lang="scss">
.notification-message {
  display: block;
  width: 100%;
  padding: 0.0625em 0.125em;
  cursor: pointer;
}
</style>
